import {
  AutoRedemptionSettingModel,
  CashAutoRedemptionSettingModelAttributes,
  CashBackAutoRedemptionType,
  DigitalGiftCardAutoRedemptionSettingModelAttributes,
  PhysicalGiftCardAutoRedemptionSettingModelAttributes,
  PointsTransferAutoRedemptionSettingModelAttributes,
} from './auto-redemption-setting.model';

export enum AutoRedemptionSettingType {
  Cash = 'cash_redemption_setting',
  PointsTransfer = 'points_transfer_setting',
  DigitalGiftCard = 'digital_gift_card_setting',
  PhysicalGiftCard = 'physical_gift_card_setting',
}

export enum AutoRedemptionSettingStrategy {
  EarliestOpportunity = 'earliest_opportunity',
  EveryFewMonths = 'every_few_months',
  EndOfMonth = 'end_of_month',
  BeginningOfMonth = 'beginning_of_month',
}

export interface PeriodAutoRedemptionSettingStrategyOptions {
  month_frequency: 1 | 3 | 6 | 12;
  start_date: string;
}

export interface PointsTransferAutoRedemptionSetting
  extends Omit<AutoRedemptionSettingModel, 'id' | 'type' | 'attributes'>,
    PointsTransferAutoRedemptionSettingModelAttributes {
  type: AutoRedemptionSettingType.PointsTransfer;
}

export interface CashRedemptionAutoRedemptionSetting<
  T extends CashBackAutoRedemptionType,
> extends Omit<AutoRedemptionSettingModel, 'id' | 'type' | 'attributes'>,
    CashAutoRedemptionSettingModelAttributes<T> {
  type: AutoRedemptionSettingType.Cash;
}

export interface DigitalGiftCardAutoRedemptionSetting
  extends Omit<AutoRedemptionSettingModel, 'id' | 'type' | 'attributes'>,
    DigitalGiftCardAutoRedemptionSettingModelAttributes {
  type: AutoRedemptionSettingType.DigitalGiftCard;
}

export interface PhysicalGiftCardAutoRedemptionSetting
  extends Omit<AutoRedemptionSettingModel, 'id' | 'type' | 'attributes'>,
    PhysicalGiftCardAutoRedemptionSettingModelAttributes {
  type: AutoRedemptionSettingType.PhysicalGiftCard;
}

export type AutoRedemptionSetting =
  | PointsTransferAutoRedemptionSetting
  | CashRedemptionAutoRedemptionSetting<CashBackAutoRedemptionType>
  | DigitalGiftCardAutoRedemptionSetting
  | PhysicalGiftCardAutoRedemptionSetting;
